import { type Message, Specs, attachHandler } from '@doxyme/extensions-common';
import ExtensionCapability from '../../capability';
import type Instance from '../../instance';
const { AlertBanner } = Specs;

type AddPayload = Specs.AlertBanner.AddPayload;
type DismissPayload = Specs.AlertBanner.DismissPayload;

type OnAddHandler = (
  payload: AddPayload,
  sendMessage: (message: Message) => void,
) => void;
type OnDismissHandler = (
  payload: DismissPayload,
  sendMessage: (message: Message) => void,
) => void;

type Constraints = Specs.AlertBanner.Constraints;

/**
 * AlertBanner Capability
 */
export default class AlertBannerCapability extends ExtensionCapability<Constraints> {
  static readonly id = AlertBanner.id;

  protected readonly addHandlers: OnAddHandler[] = [];

  protected readonly dismissHandlers: OnDismissHandler[] = [];

  constructor() {
    super(AlertBanner);

    this.handlers.push(
      [AlertBanner.Actions.Add, this.#add.bind(this)],
      [AlertBanner.Actions.Dismiss, this.#dismiss.bind(this)],
    );
  }

  onAdd(handler: OnAddHandler): () => void {
    return attachHandler<OnAddHandler>(this.addHandlers, handler);
  }

  onDismiss(handler: OnDismissHandler): () => void {
    return attachHandler<OnDismissHandler>(this.dismissHandlers, handler);
  }

  #add(payload: AddPayload, instance: Instance): void {
    for (const handler of this.addHandlers) {
      handler(payload, (message: Message) =>
        this.handleMessages(instance, [message]),
      );
    }
  }

  #dismiss(payload: DismissPayload, instance: Instance): void {
    for (const handler of this.dismissHandlers) {
      handler(payload, (message: Message) =>
        this.handleMessages(instance, [message]),
      );
    }
  }
}
